import React from 'react'

import Collapsible from 'react-collapsible';
const Br1 = () => {
    return (
        <div class='container'>
          <td>
<h1 class="h1">Blood Relations </h1>
<p>This type of reasoning question is based on the blood relations among the family members. And, you are required to find the relation between the particular members of the family. So, you must have a basic understanding of the different types of blood relations that exist in a family.</p>
<p>The following table will help you understand the different types of blood relations among the family members.</p>
<table class="alt">
<tbody><tr>
    <td>Father's or mother's son</td>
    <td>Brother</td>
</tr>
<tr>
    <td>Father's or mother's daughter</td>
    <td>Sister</td>
</tr>
<tr>
    <td>Father's elder or younger brother</td>
    <td>Uncle (Paternal)</td>
</tr>
<tr>
    <td>Mother's elder or younger brother</td>
    <td>Maternal Uncle</td>
</tr>
<tr>
    <td>Father's elder or younger sister</td>
    <td>Aunt</td>
</tr>
<tr>
    <td>Mother's elder or younger sister</td>
    <td>Aunt (Maternal)</td>
</tr>
<tr>
    <td>Son's wife</td>
    <td>Daughter-in-law</td>
</tr>
<tr>
    <td>Daughter's husband</td>
    <td>Son-in-law</td>
</tr>
<tr>
    <td>Sister's husband</td>
    <td>Brother-in-law</td>
</tr>
<tr>
    <td>Brother's wife</td>
    <td>Sister-in-law</td>
</tr>
<tr>
    <td>Husband's brother or wife's brother</td>
    <td>Brother-in-law</td>
</tr>
<tr>
    <td>Husband's sister or wife's sister</td>
    <td>Sister-in-law</td>
</tr>
<tr>
    <td>Husband's father or wife's father</td>
    <td>Father-in-law</td>
</tr>
<tr>
    <td>Husband's mother or wife's mother</td>
    <td>Mother-in-law</td>
</tr>
<tr>
    <td>Brother's son or sister's son</td>
    <td>Nephew</td>
</tr>
<tr>
    <td>Brother's daughter or sister's daughter	</td>
    <td>Niece</td>
</tr>
<tr>
    <td>Uncle's or aunt's son</td>
    <td>Cousin</td>
</tr>
<tr>
    <td>Uncle's or aunt's daughter</td>
    <td>Cousin</td>
</tr>
<tr>
    <td>Father's or mother's father</td>
    <td>Grandfather</td>
</tr>
<tr>
    <td>Father's or mother's mother</td>
    <td>Grandmother</td>
</tr>
<tr>
    <td>Father of grandfather or grandmother</td>
    <td>Great-grandfather</td>
</tr>
<tr>
    <td>Mother of grandfather or grandmother</td>
    <td>Great-grandmother</td>
</tr>
</tbody></table>
<p><strong>Note:<br/>
The relation on mother's side is called maternal, e.g., maternal uncle or aunt.<br/>
The relation on father's side is called paternal, e.g., paternal uncle or aunt.</strong></p>
<br />

<p class="pq">1) Pointing to a photograph, a man said, "I have no brother, and that man's father is my father's son." Whose photograph was it?</p>
<ol class="pointsu">
<li className='list'>His son</li> 
<li className='list'>His own</li>
<li className='list'>His father</li>
<li className='list'>His nephew</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The narrator has no brother, so he is the only son of his father, and his father's son is he himself. Hence, the narrator is the father of the man in the photograph, so the man in the photograph is his son.</p>
</div>  </Collapsible>
<br />

<p class="pq">2) Pointing to a photograph of a man, Pooja said, "He is the only son of the mother of my sister's brother." How is that person related to Pooja?</p>
<ol class="pointsu">
<li className='list'>Father</li> 
<li className='list'>Maternal Uncle</li>
<li className='list'>Cousin</li>
<li className='list'>None of these</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>The person in the photograph is the only son of the mother of Pooja's sister's brother. So, he is the brother of Pooja.</p>
</div> </Collapsible>
<br />

<p class="pq">3) Pointing to a woman, a man said, "Her father is the only son of my father." How is the man related to the woman?</p>
<ol class="pointsu">
<li className='list'>Brother</li> 
<li className='list'>Grandfather</li> 
<li className='list'>Father</li> 
<li className='list'>Son </li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>Only son of my father = the man himself. Therefore, the man is the father of this woman.</p>
</div> </Collapsible>
<br />

<p class="pq">4) Looking at the portrait of a man, Mohan said, "His mother is the wife of my father's son and I have no brother and sister." at whose portrait was Mohan looking?</p>
<ol class="pointsu">
<li className='list'>His nephew</li> 
<li className='list'>His son</li>                 
<li className='list'>His cousin</li> 
<li className='list'>None of these</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Mohan has no brother and sister, so he is the only son of his father.</p>
<p>Now, wife of my father's son = Mohan's wife. And, Mohan's wife is the mother of the man, so the man is Mohan's son.</p>
</div> </Collapsible>
<br />

<p class="pq">5) Pointing to a photograph, a lady tells Sohan, "I am the only daughter of this woman, and her son is your maternal uncle." How is the lady related to Sohan's father?</p>
<ol class="pointsu">
<li className='list'>Wife</li> 
<li className='list'>Sister-in-law</li>    
<li className='list'>Sister</li> 
<li className='list'>None of these</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>The lady's brother is Sohan's maternal uncle. So, the lady is Sohan's mother and wife of his father.</p>
</div> </Collapsible>
<br />
<br/>



<h1 class="h1">Blood Relations 2</h1>
<p class="pq">6) Looking at the picture of a man, Geeta said, "His brother's father is the only son of my grandmother. How is Geeta related to the man in the picture?</p>
<ol class="pointsu">
<li className='list'>Mother</li> 
<li className='list'>Sister</li> 
<li className='list'>Aunt</li> 
<li className='list'>Daughter</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Only son of my grandmother = Geeta's father</p>
<p>Man's brother's father = Man's father, so, Geeta is the sister of the man in the picture.</p>
</div> </Collapsible>
<br />

<p class="pq">7) Pointing to an old man, Ramesh said, "His son is my son's uncle." How is Ramesh related to the man?</p>
<ol class="pointsu">
<li className='list'>Brother</li> 
<li className='list'>Son</li> 
<li className='list'>Father</li> 
<li className='list'>Cousin </li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Ramesh's son's uncle = Ramesh's brother</p>
<p>Now, Man's son is Ramesh's brother, so Ramesh is the son of the old man.</p>
</div> </Collapsible>
<br />

<p class="pq">8) A and B are sisters. C and D are brothers. A's daughter is D's sister. How is B related to C? </p>
<ol class="pointsu">
<li className='list'>Aunt</li> 
<li className='list'>Sister</li>                  
<li className='list'>Mother</li> 
<li className='list'>None of these </li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>B is the sister of A and A's daughter is D's sister. It shows D is the son of A. Since, C and D are brothers; C is also the son of A. So, B is the aunt of C.</p>
</div> </Collapsible>
<br />

<p class="pq">9. Given that</p>
<p>I. A is the father of B</p>
<p>II. C is the daughter of A</p>
<p>III. D is the sister of E</p>
<p>IV. E is the son of B </p>
<p class="pq">Who is the grandfather of D?</p>
<ol class="pointsu">
<li className='list'>C</li>
<li className='list'>B </li>
<li className='list'>D</li>
<li className='list'>A</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<p>D is the sister of E and E is the son of B. It means, D is the daughter of B. Since, A is the father of B, so A is the grandfather of D.</p>
</div> </Collapsible>
<br />

<p class="pq">10) Sunil is the brother of Anil. Anil is the son of Sohan. Meena is Sohan's mother. How is Sunil related to Meena?</p>
<ol class="pointsu">
<li className='list'>Son</li> 
<li className='list'>Grandson</li> 
<li className='list'> Brother</li> 
<li className='list'>Grandfather</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Sunil is the brother of Anil and Anil is the son of Sohan. So, Sunil is the son of Sohan. Now, Meen is the mother of Sohan. So, Sunil is the grandson of Meena.</p>
</div> </Collapsible>
<br />
<br/>


<p class="pq">11) Rahul's father is the only son of Rohan's Father. How is Rohan's wife related to Rahul?</p>
<ol class="pointsu">
<li className='list'>Mother</li>
<li className='list'>Aunt</li>
<li className='list'>Grandmother</li>
<li className='list'> Sister</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> A </p>
<p><strong>Explanation:</strong></p>
<p>The only son of Rohan's father is Rohan himself. So, Rohan is Rahul's father, and Rohan's wife is the mother of Rahul.</p>
</div> </Collapsible>
<br />

<p class="pq">12) Manoj is the brother of Deepak.  Rekha is the sister of Seema. Deepak is the son of Rekha. How is Manoj related to Rekha?</p>
<ol class="pointsu">
<li className='list'>Nephew</li>
<li className='list'>Son </li>
<li className='list'>Brother</li>
<li className='list'>None of these</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<p>Manoj is the brother of Deepak and Deepak is the son of Rekha. So, Manoj is the son of Rekha.</p>
</div> </Collapsible>
<br />

<p class="pq">13) A is B's brother. C is B's father. D is C's father. E is D's father. How is A related to D?</p>
<ol class="pointsu">
<li className='list'>Grandson</li> 
<li className='list'>Son</li> 
<li className='list'>Nephew</li> 
<li className='list'>Grandfather</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>A and B are brothers and C is B's father, so A is the son of C. Now, D is C's father, so A is the grandson of D. </p>
</div> </Collapsible>
<br />

<p class="pq">14) P and Q are the married couple. X and Y are sisters. X is the sister of P. How is Y related to Q?</p>
<ol class="pointsu">
<li className='list'>Sister</li> 
<li className='list'>Cousin</li> 
<li className='list'>Sister-in-law</li> 
<li className='list'>Daughter-in-law</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> C</p>
<p><strong>Explanation:</strong></p>
<p>P and Q are husband and wife. X and Y are sisters and X is the sister of P. It shows Y is the sister of P, so Y is the sister-in-law of Q.</p>
</div> </Collapsible>
<br />

<p class="pq">15) Geeta and Rekha are wives of Deepak. Ravi is Rekha's stepson. How is Geeta related to Ravi?</p>
<ol class="pointsu">
<li className='list'>Mother</li>
<li className='list'>Sister</li>
<li className='list'>Step-mother</li>
<li className='list'>Mother-in-law</li>
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer15">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<p>Geeta and Rekha are wives of Deepak and Ravi is the stepson of Rekha, so Geeta is the mother of Ravi.</p>
</div> </Collapsible>
<br />
<br/>






<h1 class="h1">Blood Relations 4</h1>

<p class="pq">16) Pointing to a woman in a photograph, Ram says, "She is the only daughter of the mother-in-law of my only son." How is the woman related to Ram?</p>
<ol class="pointsu">
<li className='list'>Wife</li> 
<li className='list'>Daughter</li> 
<li className='list'>Mother</li> 
<li className='list'>Daughter-in-Law</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(1)" trigger='Show Answer'> 
<div id="workspace1"></div>
<div class="testanswer" id="answer1">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<img src="https://static.javatpoint.com/reasoning/images/blood-relation-4.png" alt="Blood Relation"/>
<p>From the diagram, it is clear that the woman in the photograph is the daughter-in-law of Ram.</p>
</div> </Collapsible>
<br />

<p class="pq">17) Pointing to a man in a photograph Mohan says, "He is the only son of my wife's mother-in-law." How is the man related to Mohan?</p>
<ol class="pointsu">
<li className='list'>Brother</li> 
<li className='list'>Son</li> 
<li className='list'>Brother-in-law</li> 
<li className='list'>Father-in-law</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(2)" trigger='Show Answer'> 
<div id="workspace2"></div>
<div class="testanswer" id="answer2">
<p><strong>Answer:</strong> A</p>
<p><strong>Explanation:</strong></p>
<img src="https://static.javatpoint.com/reasoning/images/blood-relation-4-q17.png" alt="Blood Relation"/>
<p>From the diagram, it is clear that the man in the photograph is the brother of Mohan.</p>
</div> </Collapsible>
<br />

<p class="pq">18) Pointing to a man in the photograph a woman said, "He is the son of my paternal grandmother's only son. How is the man related to the woman?</p>
<ol class="pointsu">
<li className='list'>Brother-in-law</li>
<li className='list'>Son</li>
<li className='list'>Father</li>
<li className='list'>Brother</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(3)" trigger='Show Answer'> 
<div id="workspace3"></div>
<div class="testanswer" id="answer3">
<p><strong>Answer:</strong> D</p>
<p><strong>Explanation:</strong></p>
<img src="https://static.javatpoint.com/reasoning/images/blood-relation-4-q18.png" alt="Blood Relation"/>
<p>From the diagram, it is clear that the man in the photograph is the brother of the woman.</p>
</div> </Collapsible>
<br />

<p class="pq">19) Pointing to an image Madhu tells Sohan, "I am the only daughter of this lady, and her son is your maternal uncle." How is the Madhu related to Sohan's father?</p>
<ol class="pointsu">
<li className='list'>Sister-in-law</li> 
<li className='list'>Wife</li> 
<li className='list'>Sister</li> 
<li className='list'>None of the above.</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(4)" trigger='Show Answer'> 
<div id="workspace4"></div>
<div class="testanswer" id="answer4">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<img src="https://static.javatpoint.com/reasoning/images/blood-relation-4-q19.png" alt="Blood Relation"/>
<p>From the diagram, it is clear that the Madhu is the wife of Sohan's father.</p>
</div> </Collapsible>
<br />

<p class="pq">20) Pointing to a photograph of a woman Rohan says, "She is the sister-in-law of the only daughter of my mother-in-law's husband." How is the Rohan related to the woman?</p>
<ol class="pointsu">
<li className='list'>Son</li>
<li className='list'>Brother</li> 
<li className='list'>Brother-in-law</li> 
<li className='list'>Father</li> 
</ol>
<Collapsible triggerClassName="showanswer" onclick="showhide(5)" trigger='Show Answer'> 
<div id="workspace5"></div>
<div class="testanswer" id="answer5">
<p><strong>Answer:</strong> B</p>
<p><strong>Explanation:</strong></p>
<img src="https://static.javatpoint.com/reasoning/images/blood-relation-4-q20.png" alt="Blood Relation"/>
<p>From the above diagram, it is clear that Rohan is the brother of that woman.</p>
</div> </Collapsible>
<br />



<br/><br/>
</td>
        </div>
    )
}

export default Br1
